import { useQuery } from '@tanstack/react-query';
import { WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS } from '../constants';
import { fetchWebsiteAnalyticsSummary } from '../services/websiteAnalytics.api';

export function useWebsiteAnalyticsSummary(enabled: boolean) {
  return useQuery({
    queryKey: ['website-analytics', 'summary'],
    queryFn: fetchWebsiteAnalyticsSummary,
    enabled,
    staleTime: 30_000,
    refetchInterval: enabled ? WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS : false,
    retry: 1,
  });
}
